export default "__VITE_PUBLIC_ASSET__c3d020d6__"